import React from 'react';
import SbEditable from 'storyblok-react';
import IconLink from '~/components/IconLink';
import { Link } from 'gatsby';
import renderLink from '~/utils/render-link';

const Button = ({ blok, className = '', tag='', ...other }) => {

  return (
    <SbEditable content={blok} key={blok._uid}>
      {blok?.title?.length > 0 && (
        <>
          {(!blok.type || blok.type !== 'icon-link') && (
            <Link
              to={renderLink(blok?.button?.cached_url || '#')}
              className={`c-btn c-btn--primary ${className}`}
              dangerouslySetInnerHTML={{ __html: blok.title }}
            />
          )}
          {blok.type === 'icon-link' && <IconLink type={tag||'link'} to={renderLink(blok?.button?.cached_url)} {...other}>{blok?.title}</IconLink>}
        </>
      )}
    </SbEditable>
  );
};

export default Button;
